<template>
  <div>
    <section-title content="Información de Equipo" has-line class="mt-4" />

    <div class="row">
      <div
        class="col-12 col-md-2"
        v-for="(property, key) in equipment.properties"
        :key="key"
      >
        <div class="p-2">
          <p class="font-14 text-muted mb-0">
            {{ property.id }}
          </p>
          <p class="font-16 mb-0">
            {{ property.name | empty }}
          </p>
        </div>
      </div>
    </div>
    <div class="m-2">
      <p class="font-14 text-muted mb-1">
        Descripción:
      </p>
      <p class="font-16">
        {{ equipment.description | empty }}
      </p>
    </div>
    <div class="m-2">
      <p class="font-14 text-muted mb-1">
        Datos de Ubicación / Dirección:
      </p>
      <p class="font-16">
        {{ equipment.address | empty }}
      </p>
    </div>
    <div class="m-2">
      <p class="font-14 text-muted mb-2">
        Accesorios:
      </p>
      <div class="row mx-0">
        <div
          class="col-12 col-lg-3 pl-0"
          v-for="(accessory, index) in equipment.accessoriesDetails"
          :key="index"
        >
          <div class="p-2 bg-gray rounded">
            <p class="font-16 font-weight-bold mb-0">
              {{ accessory.name }}
            </p>
            <p class="font-14 mb-0">
              <span class="text-muted">
                {{ accessory.detailModel }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';

export default {
  name: 'EquipmentInformation',
  components: {
    SectionTitle,
  },
  props: {
    equipment: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped></style>
